export enum PromoCampaignType {
    TRIAL_LINK = 'trial',
    PROMOTIONAL_CAMPAIGN = 'promo'
}
